import React, { useState, useEffect } from 'react';
import styles from '../styles.module.css';
import { FaPlus } from 'react-icons/fa6';
import { FiMinus } from 'react-icons/fi';
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import { Table } from 'antd';
import BookingCancel from './BookingCancel';
import { FaCopy } from "react-icons/fa"
import { Button,Tag } from 'antd';
import AdminTransactionView from './AdminTransactionView';

const TransactionBlock = ({ userID }) => {
  const [ariaExpand, setAriaExpand] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isFinancialDataLoading, setIsFinancialDataLoading] = useState(true);
  const [transactionData, setTransactionData] = useState(null);
  const [userFinancialData, setUserFinancialData] = useState(null);
  

  const [pagination, setPagination] = useState({
    total: 0,
    current: 1,
    pageSize: 10,
    totalPages: 0
  });



  useEffect(() => {
    setTransactionData(null);
    setAriaExpand(false);
    setIsLoading(true);
  }, [userID]);

  function timestampToDate(timestamp) {
    const milliseconds = timestamp * 1000;
    const date = new Date(milliseconds);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedDate = `${day < 10 ? '0' : ''}${day}/${month < 10 ? '0' : ''}${month}/${year}, ${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;

    return formattedDate;
  }



  const fetchTransaction = async (page = 1, pageSize = 10, isPaging = false) => {
    try {
      setIsLoading(true);
      const data = await BreathAPIs.getTransactionHistoryAdmin(userID, page, pageSize);
      setTransactionData(data.data.transactionHistory);

      setPagination({
        total: data.data.pagination.total,
        current: data.data.pagination.current,
        pageSize: data.data.pagination.pageSize,
        totalPages: data.data.pagination.totalPages
      });

    } catch (error) {
      console.error('Error fetching transaction data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserFinancialData = async () => {
    try {
      setIsFinancialDataLoading(true);
      const data = await BreathAPIs.getUserFinancialData(userID);
      setUserFinancialData(data.data.data);
    } catch (error) {
      console.error('Error fetching User financial data:', error);
    } finally {
      setIsFinancialDataLoading(false);
    }
  };


const handleCopy = (amount) => {
  navigator.clipboard.writeText(amount)
}

  useEffect(() => {
    if (ariaExpand) {
      fetchTransaction();
      fetchUserFinancialData();
    }
  }, [ariaExpand]);

 

  const columnTransactions = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (text, record) => {
        return (
          <div>
            {timestampToDate(record.date)} 
          {
            (record.updatedBy==='Admin' || record.updatedBy==='Breathe-Admin') &&
            <AdminTransactionView record={record} />
          }
          {<BookingCancel timeFormatAmPm={true} history={record} />}

          </div>
        )
      }
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (text, record) => {
        return (
          <div className={record.type?.toLowerCase() === 'debit' ? 'text-danger text-end' : 'text-success text-end'}>{record.type?.toLowerCase() === 'debit' ? '-$' : '+$'}{record.amount?.toFixed(2)} 
          <Button
            icon={<FaCopy/>}
            onClick={()=>handleCopy(record.amount) }
            style={{ cursor: "pointer", marginLeft: 8 }}
            size='small'
          />
          </div>
        )
      }
    },

  ];


  const handleTableChange = (pagination) => {
    const { current, pageSize } = pagination;
    console.log(pageSize);
    fetchTransaction(current, pageSize);
  };


  return (
    <div className={styles['transaction-block']}>
      <button onClick={() => setAriaExpand(!ariaExpand)} className={styles['expand-button']}>
        {ariaExpand ? <FiMinus /> : <FaPlus />}transactions
      </button>
     

      {(ariaExpand) && (
        <div className={styles['data']}>
          {/* <div className={styles['data-row']}>Wallet Sum <span>$0</span></div> */}
          {isFinancialDataLoading ?
            <div>loading...</div>
            :
            <div className={styles.topBlockContainer}>
              <div className={styles.topBlock}>Cancellation Amount<span>${userFinancialData?.BookingCancellationAmount?.toFixed(2)}</span></div>
              <div className={styles.topBlock}>Revenue<span>${userFinancialData?.Revenue?.toFixed(2)}</span></div>
              <div className={styles.topBlock}>User Credits<span>${userFinancialData?.creditByUser?.toFixed(2)}</span></div>
              <div className={styles.topBlock}>Admin Credits<span>${userFinancialData?.creditByAdmin?.toFixed(2)}</span></div>
            </div>}
          <Table
            style={{ margin: '4px' }}
            loading={isLoading}
            dataSource={transactionData}
            columns={columnTransactions}
            rowKey="_id"
            pagination={pagination}
            onChange={handleTableChange}
            className={styles['data-list']}
            bordered
            size="middle"
          />

        </div>
      )}

    </div>
  );
};

export default TransactionBlock;
